import React from 'react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Products } from './Products';
import { Orders } from './Orders';
import { OrderHistory } from './OrderHistory';
import { Profile } from './Profile';
import { Instructions } from './Instructions';
import { Package, ShoppingCart, User, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ProducerOnboarding } from './ProducerOnboarding';

export function ProducerPortal() {
  const { profile } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (profile?.role !== 'producer') {
    return <Navigate to="/" replace />;
  }

  const navigation = [
    { name: t('producer.products'), to: '/producer/products', icon: Package },
    { name: t('producer.orders'), to: '/producer/orders', icon: ShoppingCart },
    { name: t('producer.profile'), to: '/producer/profile', icon: User },
    { name: t('producer.instructions'), to: '/producer/instructions', icon: FileText }
  ];

  return (
    <div className="min-h-full bg-gray-100 py-6">
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <aside className="py-6 px-2 sm:px-6 lg:col-span-3 lg:py-0 lg:px-0">
            <nav className="space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  className={
                    `group flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                      location.pathname === item.to
                        ? 'bg-gray-50 text-green-700 hover:text-green-700 hover:bg-white'
                        : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'
                    }`
                  }
                >
                  <item.icon
                    className={`flex-shrink-0 -ml-1 mr-3 h-6 w-6 ${
                      location.pathname === item.to
                        ? 'text-green-500'
                        : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  <span className="truncate">{item.name}</span>
                </Link>
              ))}
            </nav>
          </aside>

          <div className="space-y-6 sm:px-6 lg:col-span-9 lg:px-0">
            <Routes>
              <Route index element={<Navigate to="/producer/products" replace />} />
              <Route path="products/*" element={<Products />} />
              <Route path="orders" element={<Orders />} />
              <Route path="orders/history" element={<OrderHistory />} />
              <Route path="profile" element={<Profile />} />
              <Route path="instructions" element={<Instructions />} />
              <Route path="onboarding" element={<ProducerOnboarding />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}